<template>
    <EditServiceReport3></EditServiceReport3>
</template>
<script>
    import EditServiceReport3 from '@/components/EditServiceReport3.vue'
    export default {
        name: 'employee-sign',
        components: {
            EditServiceReport3
        }
    }
</script>